import { useState, useCallback } from "react";

export function usePhytosanitaryProductRemoval({ handleSave }) {
	const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
	const [productToRemove, setProductToRemove] = useState(null);

	const handleRemoveProduct = useCallback((row) => {
		setProductToRemove(row);
		setConfirmModalOpen(true);
	}, []);

	const confirmRemoveProduct = useCallback(() => {
		if (productToRemove) {
			handleSave({
				recordId: productToRemove.id,
				originalRow: productToRemove,
				fieldName: "delete_product",
				newValue: productToRemove.product_id,
			});
		}
		setConfirmModalOpen(false);
		setProductToRemove(null);
	}, [productToRemove, handleSave]);

	const cancelRemoveProduct = useCallback(() => {
		setConfirmModalOpen(false);
		setProductToRemove(null);
	}, []);

	return { isConfirmModalOpen, productToRemove, handleRemoveProduct, confirmRemoveProduct, cancelRemoveProduct };
}
